document.addEventListener("DOMContentLoaded", function () {
    const thumbnails = document.querySelectorAll(".block__gift-card-media-bottom .product-single__media");
    const mainImages = document.querySelectorAll(".block__gift-card-media-top .product-single__media");

    thumbnails.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const mediaId = thumb.getAttribute("data-media-id");

        mainImages.forEach((img) => {
          img.classList.add("hidden");
        });

        thumbnails.forEach((t) => {
          t.classList.remove("active");
        });

        const selectedImage = document.querySelector(`.block__gift-card-media-top .product-single__media[data-media-id="${mediaId}"]`);
        if (selectedImage) {
          selectedImage.classList.remove("hidden");
        }

        thumb.classList.add("active");
      });
    });
});